import template from '../../../../ui-formly/partials/form.html'
import FormControllerFactory from '../../../../ui-formly/controllers/FormControllerFactory'
import formly from './formly'
import authenticationService from '../../../authorization/authService'
import asyncValidators from '../../../validation/asyncValidators/index'
import server from '../../../server/index'

titleEdit.vsName = 'titleEdit'
titleEdit.vsNgType = 'directive'

titleEdit.$inject = [server.vsName, asyncValidators.vsName]
function titleEdit(server, asyncValidators) {  
  return {
    templateUrl: template,
    transclude: false,
    restrict: 'E',
    scope: {
      model:'=?'
    },  
    controller: FormControllerFactory({      
      returnState: 'main.titles.grid',
      formFields: formly(server, asyncValidators, authenticationService),
      submit: server.titleSave 
    }),
    controllerAs: 'ctrl',
    bindToController: true
  }
}

export default titleEdit
